import { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";
import { api, errMsg } from "../lib/api";

const D = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
  [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
  [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]];
const P = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
  [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]];

export const aadhaarError = (v) => {
  const s = (v || "").replace(/\D/g, "");
  if (!s) return "";
  if (!/^[2-9]\d{11}$/.test(s)) return "Aadhaar must be 12 digits and cannot start with 0 or 1";
  let c = 0;
  [...s].reverse().forEach((ch, i) => { c = D[c][P[i % 8][+ch]]; });
  return c ? "This Aadhaar number is not valid — please check for a typing mistake" : "";
};

export const formatAadhaar = (v) => (v || "").replace(/\D/g, "").slice(0, 12).replace(/(\d{4})(?=\d)/g, "$1 ");

export function AadhaarInput({ value, onChange, last4, onRemove }) {
  const err = aadhaarError(value);
  return (
    <label className="block">
      <span className="mb-2 block text-xs font-medium text-zinc-400">Aadhaar number (optional)</span>
      <input className={`field font-mono tracking-wider ${err ? "!border-rose-400/60" : ""}`} inputMode="numeric" autoComplete="off" value={formatAadhaar(value)}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 12))} placeholder={last4 ? `XXXX XXXX ${last4} — type to change` : "XXXX XXXX XXXX"} data-testid="student-aadhaar-input" />
      {err && value.length === 12 ? <span className="mt-1 block text-xs text-rose-300" data-testid="student-aadhaar-error">{err}</span>
        : last4 && onRemove ? <button type="button" className="mt-1 text-xs text-zinc-500 hover:text-rose-300" onClick={onRemove} data-testid="student-aadhaar-remove">Remove saved Aadhaar</button> : null}
    </label>
  );
}

export function AadhaarView({ sid, masked, isAdmin }) {
  const [full, setFull] = useState("");
  const reveal = async () => {
    if (full) return setFull("");
    try {
      setFull((await api.get(`/students/${sid}/aadhaar`)).data.aadhaar);
    } catch (e) {
      setFull("");
      alert(errMsg(e));
    }
  };
  if (!masked) return <span data-testid="detail-aadhaar">—</span>;
  return (
    <span className="inline-flex items-center gap-2">
      <span className="font-mono" data-testid="detail-aadhaar">{full ? formatAadhaar(full) : masked}</span>
      {isAdmin && <button className="text-zinc-500 hover:text-white" onClick={reveal} title={full ? "Hide" : "Show full number"} data-testid="detail-aadhaar-reveal">{full ? <EyeSlash size={15} /> : <Eye size={15} />}</button>}
    </span>
  );
}
